import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["srcDark", "src"];
import { useTheme } from '@material-ui/core';
import { jsx as _jsx } from "react/jsx-runtime";
export function Image(_ref) {
  var {
      srcDark,
      src
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var value = theme.palette.type === 'dark' && srcDark ? srcDark : src;
  return /*#__PURE__*/_jsx("img", _objectSpread(_objectSpread({}, props), {}, {
    src: value
  }));
}